// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"3fe169f4","257":"52a93b43","412":"b6fcd32f"}[chunkId] + ".chunk.css";
};